var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0357143 0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 28,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAeCAYAAAA/xX6fAAACsUlEQVRIS+WWz29UVRTHP9/7nHHAhoAYNlVoTUmI7El3TkxMZC8LNxhX/g1sSN2xdEkIC1cmprrRhTEs5FdMFIkxBpCIhVpAJwSlzQDtzNzzJW9akjqdYWqAEsNJXt7Lyzn3e7/nfM89V2m8HoBYlzlwOhSbX/mYVrNW5HsnjPatK3TZaVHPEtBAC3wbVLLuYw7EkdjWPM78jk09DNvAHeDuIxgvrWaYgStIx7Qc2MfCGf/IzFsXmPh+pAewAUzLnB0IKPJqwI7wd7lTfY+5EzeH1mVi/5Z/AZrflXQ4z3z76aNinytAB+gm6GvkAYXXXLSqn3D9m7/pTSn8Yzgr+dKglMr6ZXVKS5WW6lwEyu81Jvgpm4NcO3ltLWB3w0vgUq0DTF/+tz4058NxgNnTV/swHKozwxe9DBcEvy7341ozXI7Ih5k982cfwPvArODWIGTDqedKpfzPGh/PiPRRLmqfDVRPdcRProYwbzgn67fBXRHtJwk4tC165+Hj1XA9cN0B/Hp9CixCoeQ/ck3TXDzZHBo/sf/FIt87aPHqUN+HDi6FucEm3qiPbCSm0vibP28coLoTv+9keEqb6JQMbz+lxfst21Eaq3+4cYDyM1DpWH2SIm50WXYYoVIkXLmFikV8fwcOEWluJQt7iGKBam7haqvr0747SkEH1eaJLDqpIC2aygsv03EmRYVIbaJIpFwtG/+o0Fe2x7C2gxtKup5xo0C7HH4tnE5TYT7l+EDoB5t3SF6Qfd7WqFTehcrjI0YxE4grOG0SbljeKdJlh3eT2KZivP5uzsXFlPLbwFbgL6BGUhvHS6AtgT6nUDNlvy/inKW9mO1CZ2wmSW4puIqoGO3ENElRiNQwsUuhS90Tydpc1rB8DFOpv3guCKbLy9WKz1T5Fjz8f2Albu+62usBNcvkmgWkyQ0AAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.f05092206a27e4f53a25e235bd443d4d.svg";
export { ForwardRef as ReactComponent };